import { useSecuredRoutes } from 'modules/auth'

import routes from './routes'

export const App = () => {
  const element = useSecuredRoutes(routes)
  return element
}

export default App
